import React, { useState, useRef, useEffect } from 'react';
import {
    Box,
    Grid,
    Paper,
    Typography,
    TextField,
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Stepper,
    Step,
    StepLabel,
    Theme,
    StepIcon,
    StepIconProps,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GradeIcon from '@mui/icons-material/Grade';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import GridViewIcon from '@mui/icons-material/GridView';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import StarIcon from '@mui/icons-material/Star';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import LockIcon from '@mui/icons-material/Lock';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KenInput from '../../../../../GlobalComponents/KenInput';
import Availability from './Components/Availability';
import GradeSettings from '../Assessment/Components/GradeSettings';
import SubmissionSettings from './Components/SubmissionSettings';
import Feedback from './Components/Feedback';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import KenSnackbar from '../../../../../GlobalComponents/KenSnackbar';
import KenLoader from '../../../../../GlobalComponents/KenLoader';
import { createAssignmentAPI, postCoreFileUpload, getAssignmentDetails, updateAssignmentSettings } from '../../../../../Utils/apiService';
import routes from '../../../../../Utils/routes';
import { Close } from '@mui/icons-material';
import _ from 'lodash';
// import TimeSettings from './Components/Timesettings';
// import GradeSettings from './Components/GradeSettings';
// import QuestionBehaviour from './Components/QuestionBehaviour';
// import LayoutSettings from './Components/LayoutSettings';
// import KenInput from '../../../../../GlobalComponents/KenInput';
// import ReviewOptions from './Components/ReviewOptions';
// import Appearance from './Components/Appearence';
// import RestrictAccess from './Components/RestrictAccess';

// Define the form input types
export interface IAssignment {
    method: string;
    name: string;
    description: string;
    alwaysshowdescription: number;
    showdescription: number;
    introattachments: string;
    allowsubmissionsfromdate: any;
    duedate: any;
    cutoffdate: string;
    gradingduedate: string;
    assignsubmission_file_enabled: number;
    assignsubmission_comments_enabled: number;
    assignsubmission_onlinetext_wordlimit: number;
    assignsubmission_file_maxfiles: number;
    assignsubmission_file_maxsizebytes: number;
    assignsubmission_file_filetypes: string;
    assignsubmission_onlinetext_enabled: number;
    assignsubmission_onlinetext_wordlimit_enabled: number;
    assignfeedback_comments_enabled: number | boolean;
    assignfeedback_editpdf_enabled: number;
    assignfeedback_comments_commentinline: number;
    maxattempts: number;
    grade: number;
    grade_rescalegrades: string;
    advancedgradingmethod_submissions: string;
    gradecat: number;
    gradepass: number;
    assignfeedback_offline_enabled: number;
    assignfeedback_file_enabled: number | boolean;
    courseoffering: string;
    visible: number;
    mform_isexpanded_id_availability: number;
    assignmentid?: string;

}

export interface ISubmissiontype {
    "type": string;
    "ext": string;
    "value": boolean,
    "label": string;
    "disable": boolean
}
// Tab definition interface
interface Tab {
    id: string;
    label: string;
    icon: React.ReactNode;
}

// Create styles using makeStyles
const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        height: 'calc(100vh - 160px)',
        gap: '12px',
    },
    leftPanel: {
        width: 280,
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: theme.spacing(3),
        paddingBottom: 0,
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
    },
    rightPanel: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
    },
    contentArea: {
        flex: 1,
        padding: theme.spacing(2),
        overflowY: 'auto',
    },
    buttonArea: {
        padding: theme.spacing(2, 4),
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'flex-end',
        backgroundColor: '#fff',
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
    },
    formControl: {
        marginBottom: theme.spacing(3),
    },
    inputLabel: {
        textAlign: 'left',
        display: 'block',
        marginBottom: theme.spacing(1),
        fontWeight: 500,
    },
    textField: {
        width: '100%',
    },
    select: {
        width: '100%',
    },
    textarea: {
        width: '100%',
        minHeight: 150,
    },
    cancelButton: {
        marginRight: theme.spacing(2),
    },
    saveButton: {
        backgroundColor: '#3986c8',
        '&:hover': {
            backgroundColor: '#2d6da3',
        },
    },
    stepperRoot: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    step: {
        '& .MuiStepLabel-root': {
            alignItems: 'flex-start',
        },
        '& .MuiStepIcon-root': {
            color: '#3986c8',
        },
        '& .MuiStepIcon-root.Mui-active': {
            color: '#3986c8',
        },
        '& .MuiStepLabel-label': {
            marginTop: 0,
            textAlign: 'left',
        },
    },
    activeStep: {
        '& .MuiStepIcon-root': {
            color: '#3986c8',
        },
    },
    completedStep: {
        '& .MuiStepIcon-root': {
            color: '#4caf50',
        },
        '& .MuiStepLabel-label': {
            color: '#4caf50',
        },
    },
    title: {
        marginBottom: theme.spacing(4),
    },
    requiredIndicator: {
        color: 'red',
    },
    tabsList: {
        padding: 0,
        flexGrow: 1,
        overflowY: 'auto',
        '& > .MuiListItem-root:last-child': {
            marginBottom: theme.spacing(1),
        },
    },
    tabItem: {
        paddingLeft: 0,
        paddingRight: 0,
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderRadius: '8px',
        },
    },
    tabItemActive: {
        backgroundColor: 'rgba(57, 134, 200, 0.1)',
        borderRadius: '8px',
    },
    tabIcon: {
        minWidth: '40px',
        color: '#666',
    },
    tabText: {
        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '1rem',
        },
    },
    activeTabText: {
        '& .MuiTypography-root': {
            fontWeight: 500,
            color: '#3986c8',
        },
    },
    activeTabIcon: {
        color: '#3986c8',
    },
    sectionTitle: {
        fontSize: '16px',
        fontWeight: '500 !important',
        color: '#333',
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(6),
        display: 'flex',
        alignItems: 'center',
        '&:first-child': {
            marginTop: 0,
        },
    },
    sectionIcon: {
        marginRight: theme.spacing(1),
        color: '#3986c8',
    },
    sectionContent: {
        marginBottom: theme.spacing(4),
        background: "#F6F8Fb",
        padding: theme.spacing(3),
        borderRadius: "12px"
    },
    sectionDivider: {
        margin: theme.spacing(4, 0),
    },
    assessmentSettings: {
        background: '#F6F8FB'
    },
    font16_500: {
        fontSize: "16px",
        fontWeight: "500"
    },
    font14_400: {
        fontSize: "14px",
        fontWeight: "400"
    }
}));

const CustomStepIcon = (props: StepIconProps) => {
    const { active, completed } = props;

    return (
        <>
            {completed ? (
                <CheckCircleIcon style={{ color: '#4caf50' }} />
            ) : (
                <StepIcon {...props} />
            )}
        </>
    );
};

const steps = ['General', 'Assignment settings'];

const mainTabs: Tab[] = [
    { id: 'Availability', label: 'Availability', icon: <AccessTimeIcon /> },
    { id: 'Grade', label: 'Grade', icon: <GradeIcon /> },
    { id: 'Submission', label: 'Submission', icon: <QuestionAnswerIcon /> },
    { id: 'Feedback', label: 'Feedback', icon: <QuestionAnswerIcon /> },
    { id: 'tags', label: 'Tags', icon: <LocalOfferIcon /> },
];

const AssignmentForm: React.FC = () => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [completedSteps, setCompletedSteps] = useState<number[]>([]);
    const [activeTab, setActiveTab] = useState('Availability'); // Changed initial tab to match new ID
    const [sectionsInitialized, setSectionsInitialized] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [operation, setOperation] = useState('Create');
    const [urlAssignmentId, setUrlAssignmentId] = useState<string | null>(null);
    const [previewData, setPreviewData] = useState<any>(null);
    const [configData, setConfigData] = useState<any>(null);
    const [fileFormatLists, setFileFormatLists] = React.useState<ISubmissiontype[]>([
        {
            "type": "pdf",
            "ext": ".pdf",
            "value": true,
            "label": "PDF document (.pdf)",
            "disable": true
        }
    ])
    const [fileDetial, setFileDetail] = React.useState({
        filecontent: null as string | ArrayBuffer | null,
        fileName: '',
    });
    // Snackbar state with explicit initial values
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
    const [isFileUploadEnabled, setIsFileUploadEnabled] = useState(false);
    const location = useLocation();
    const { title, courses, type, courseId, tab, id } = location.state || {
        title: '',
        courses: null,
        type: '',
        courseId: '',
        tab: ""
    };
    console.log(id, type, "courseId")
    const [assignData, setAssignData] = useState<IAssignment>({
        method: 'post',
        name: "",
        description: "",
        alwaysshowdescription: 1,
        showdescription: 0,
        introattachments: "0",
        allowsubmissionsfromdate: "",
        duedate: "",
        cutoffdate: "",
        gradingduedate: "",
        assignsubmission_file_enabled: 1,
        assignsubmission_comments_enabled: 1,
        assignsubmission_onlinetext_wordlimit: 1000,
        assignsubmission_file_maxfiles: 1,
        assignsubmission_file_maxsizebytes: 2097152,
        assignsubmission_file_filetypes: "",
        assignsubmission_onlinetext_enabled: 1,
        assignsubmission_onlinetext_wordlimit_enabled: 1,
        assignfeedback_comments_enabled: 1,
        assignfeedback_editpdf_enabled: 1,
        assignfeedback_comments_commentinline: 0,
        maxattempts: 1,
        grade: 0,
        grade_rescalegrades: "",
        advancedgradingmethod_submissions: "",
        gradecat: 1,
        gradepass: 0,
        assignfeedback_offline_enabled: 0,
        assignfeedback_file_enabled: 1,
        visible: 0,
        courseoffering: "",
        mform_isexpanded_id_availability: 0
    });


    const navigate = useNavigate();
    const contentRef = useRef<HTMLDivElement>(null);
    const sectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

    const { control, handleSubmit, reset } = useForm<IAssignment>();
    const getBase64FromUrl = async (url: string) => {
        try {
            const data = await fetch(url);
            const blob = await data.blob();
            return new Promise<string>((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    const base64data = reader.result as string;
                    const base64result = base64data.split(';base64,')[1];
                    resolve(base64result);
                };
            });
        } catch (error) {
            console.error("Error fetching base64 from URL:", error);
            return null;
        }
    };
    useEffect(() => {

        checkForAssignmentId();
    }, []);
    const checkForAssignmentId = async () => {
        const stateId = location.state?.id;
        let urlId = null;
        if (!stateId) {
            const url = window.location.href;
            const slashIndex = url.lastIndexOf('/');
            const possibleId = url.substr(slashIndex + 1, url.length);
            if (possibleId && !possibleId.includes('?') && /^\d+$/.test(possibleId)) {
                urlId = possibleId;
            }
        }

        const assignmentId = stateId || urlId;
        console.log(assignmentId, "assignmentId")

        if (assignmentId) {
            setIsLoading(true);
            setOperation('Edit');
            setUrlAssignmentId(assignmentId);

            try {
                const payload = { method: 'get', assignid: assignmentId };
                const res = await getAssignmentDetails(payload);

                if (res && res.assignment && res.assignment[0]) {
                    const assignment = res.assignment[0];

                    // Process file attachments if any
                    let base64DataFromURL = null;
                    if (assignment?.introattachments &&
                        assignment.introattachments.length > 0 &&
                        assignment.introattachments[0]?.fileurl) {

                        const fileUrl = assignment.introattachments[0].fileurl;
                        // Assuming you have a token available in your context
                        const token = localStorage.getItem('token') || '';
                        base64DataFromURL = await getBase64FromUrl(`${fileUrl}?token=${token}`);

                        if (base64DataFromURL) {
                            setIsFileUploadEnabled(true);
                            setFileDetail({
                                filecontent: base64DataFromURL,
                                fileName: assignment.introattachments[0].filename || ''
                            });
                        }
                    }

                    // Process configuration data
                    const configObj: Record<string, any> = {};
                    if (assignment.configs && Array.isArray(assignment.configs)) {
                        assignment.configs.forEach((item: any) => {
                            configObj[`${item.plugintype}_${item.name}`] = item.value;
                        });
                        setConfigData(configObj);

                        // Update file types if config has them
                        if (configObj.file_filetypeslist) {
                            updateFileTypes(configObj.file_filetypeslist);
                        }
                    }

                    // Store preview data with base64 attachment
                    setPreviewData({ ...assignment, base64DataFromURL });

                    // Update the form with data from API
                    setAssignData({
                        ...assignData,
                        name: assignment.name || "",
                        description: assignment.intro || "",
                        allowsubmissionsfromdate: assignment.allowsubmissionsfromdate ?
                            dayjs(assignment.allowsubmissionsfromdate):
                            "",
                        duedate: assignment.duedate ?
                            dayjs(assignment.duedate):
                            "",
                        maxattempts: assignment.maxattempts || 1,
                        assignsubmission_onlinetext_enabled: configObj?.onlinetext_enabled ?
                            Number(configObj.onlinetext_enabled) : 1,
                        assignsubmission_onlinetext_wordlimit_enabled: configObj?.onlinetext_wordlimitenabled ?
                            Number(configObj.onlinetext_wordlimitenabled) : 1,
                        assignsubmission_file_enabled: configObj?.file_enabled ?
                            Number(configObj.file_enabled) : 1,
                        assignsubmission_onlinetext_wordlimit: configObj?.onlinetext_wordlimit ?
                            Number(configObj.onlinetext_wordlimit) : 1000,
                        assignsubmission_file_maxfiles: configObj?.file_maxfilesubmissions ?
                            Number(configObj.file_maxfilesubmissions) : 1,
                        assignsubmission_file_maxsizebytes: configObj?.file_maxsubmissionsizebytes ?
                            Number(configObj.file_maxsubmissionsizebytes) : 2097152,
                        grade: assignment.grade || 0,
                        gradepass: Math.round(assignment.gradepass) || 0,
                        assignfeedback_file_enabled: assignment.assignfeedback_file_enabled ?
                            Boolean(Number(assignment.assignfeedback_file_enabled)) : true,
                        assignfeedback_comments_enabled: assignment.assignfeedback_comments_enabled ?
                            Boolean(Number(assignment.assignfeedback_comments_enabled)) : true,
                    });

                    reset({
                        name: assignment.name || "",
                        description: assignment.intro || ""
                    });
                }

            } catch (error) {
                console.error("Error fetching assignment details:", error);
                showSnackbar("Failed to load assignment details", "error");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const updateFileTypes = (fileTypesString: string) => {
        if (typeof fileTypesString !== 'string') {
            return;
        }

        const fileTypes = fileTypesString.split(',');

        setFileFormatLists(prevList =>
            prevList.map(item => ({
                ...item,
                value: fileTypes.includes(item.ext)
            }))
        );
    };

    const onSubmit: SubmitHandler<IAssignment> = (data) => {
        const { name, description } = data;
        if (!completedSteps.includes(activeStep)) {
            setCompletedSteps([...completedSteps, activeStep]);
        }
        setActiveStep(1);
        setActiveTab('Availability'); // Changed to match new tab ID
        setAssignData({
            ...assignData,
            name,
            description
        })
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setAssignData({
            ...assignData,
            [name]: value
        })
        console.log(name, value)
    }

    const handleCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target
        setAssignData({
            ...assignData,
            [name]: checked
        })
    }

    const handleSubmissionFileType = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target
        setFileFormatLists(prevList =>
            prevList.map(item =>
                item.ext === name ? { ...item, value: checked } : item
            )
        )

    }

    const handleSave = async () => {
        try {
            setIsLoading(true);

            let assignPayload = {
                ...assignData,
                allowsubmissionsfromdate: dayjs(assignData.allowsubmissionsfromdate).unix(),
                duedate: dayjs(assignData.duedate).unix(),
                assignsubmission_file_filetypes: fileFormatLists.filter(X => X.value).map(x => x.ext).toString(),
                courseoffering: courses?.CourseOfferingID || "",
                assignfeedback_comments_enabled: typeof assignData.assignfeedback_comments_enabled === 'boolean'
                    ? (assignData.assignfeedback_comments_enabled ? 1 : 0)
                    : assignData.assignfeedback_comments_enabled,
                assignfeedback_file_enabled: typeof assignData.assignfeedback_file_enabled === 'boolean'
                    ? (assignData.assignfeedback_file_enabled ? 1 : 0)
                    : assignData.assignfeedback_file_enabled,
                assignsubmission_comments_enabled: typeof assignData.assignsubmission_comments_enabled === 'boolean'
                    ? (assignData.assignsubmission_comments_enabled ? 1 : 0)
                    : assignData.assignsubmission_comments_enabled,
                assignsubmission_onlinetext_wordlimit_enabled: typeof assignData.assignsubmission_onlinetext_wordlimit_enabled === 'boolean'
                    ? (assignData.assignsubmission_onlinetext_wordlimit_enabled ? 1 : 0)
                    : assignData.assignsubmission_onlinetext_wordlimit_enabled
            };

            if (isFileUploadEnabled && fileDetial.filecontent) {
                let fileUploadPayload = {
                    contextid: '0',
                    component: 'user',
                    filearea: 'draft',
                    itemid: '0',
                    filepath: '/',
                    filename: fileDetial.fileName,
                    filecontent: typeof fileDetial.filecontent === 'string' ? fileDetial.filecontent : "",
                    contextlevel: 'user',
                    instanceid: '2',
                };

                try {
                    const fileRes = await postCoreFileUpload(fileUploadPayload);
                    if (fileRes?.itemid) {
                        assignPayload.introattachments = fileRes.itemid;
                    }
                } catch (error) {
                    console.error("Error uploading file:", error);
                    showSnackbar("Error uploading file", "error");
                    setIsLoading(false);
                    return;
                }
            } else {
                assignPayload.introattachments = "0";
            }

            if (operation === 'Edit' && urlAssignmentId) {
                assignPayload.assignmentid = urlAssignmentId;

                const { courseoffering, mform_isexpanded_id_availability, ...updatedPayload } = assignPayload;

                await updateAssignment(updatedPayload);
            } else {
                await saveAssignment(assignPayload);
            }

        } catch (error) {
            setIsLoading(false);
            console.error(`Error while ${operation === 'Create' ? 'creating' : 'updating'} assignment`, error);
            showSnackbar(`Error ${operation === 'Create' ? 'creating' : 'updating'} assignment`, "error");
        }
    };



    const updateAssignment = async (payload: any) => {
        try {
            const response = await updateAssignmentSettings(payload);
            setIsLoading(false);

            if (Array.isArray(response) && response[0]?.status === true) {
                showSnackbar("Assignment updated successfully", "success");
                setTimeout(() => {
                    navigate(`${routes.courseElaborate}?courseid=${courses?.Id || courseId}&tab=${tab}`);
                }, 1000);
            } else {
                showSnackbar("Assignment update failed", "error");
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error updating assignment:", error);
            showSnackbar("Error updating assignment", "error");
        }
    };

    const saveAssignment = async (payload: any) => {
        try {
            setIsLoading(true);
            const response = await createAssignmentAPI(payload)
            setIsLoading(false);
            if (!response.hasOwnProperty('errorcode')) {
                showSnackbar(`Assignment ${type == "add" ? 'created' : 'updated'} successfully`, "success");
                setTimeout(() => {
                    navigate(`${routes.courseElaborate}?courseid=${courses.Id || courseId}&tab=${tab}`);
                }, 1000);
            } else {
                showSnackbar(`Assignment not ${type == "add" ? 'created' : 'updated'}`, "error");
            }
        } catch (error) {
            setIsLoading(false);
            console.log(`Error while ${type == "add" ? 'created' : 'updated'} Assignment`, error);
            showSnackbar(`Error ${type == "add" ? 'created' : 'updated'} Assignment`, "error");
        }
    }

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files && event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = (reader.result as string).split(',')[1];
                setFileDetail({
                    filecontent: reader.result,
                    fileName: file.name
                });
            };
            reader.onerror = (error) => {
                console.error("Error converting file:", error);
            };
        }
    };

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
        // Scroll to the corresponding section
        if (sectionRefs.current[tabId] && contentRef.current) {
            sectionRefs.current[tabId]?.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Initialize sections
    useEffect(() => {
        if (activeStep === 1) {
            // Use a short timeout to ensure elements are in the DOM
            const timer = setTimeout(() => {
                setSectionsInitialized(true);
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [activeStep]);

    // Update active tab based on scroll position
    useEffect(() => {
        if (activeStep !== 1 || !contentRef.current || !sectionsInitialized) return;

        const handleScroll = () => {
            if (!contentRef.current) return;

            const scrollContainer = contentRef.current;
            const scrollPosition = scrollContainer.scrollTop;
            const containerHeight = scrollContainer.clientHeight;
            const containerScrollHeight = scrollContainer.scrollHeight;

            // Calculate the distance from the bottom of the scroll container
            const distanceFromBottom = containerScrollHeight - (scrollPosition + containerHeight);

            // If we're near the bottom, activate the last tab
            if (distanceFromBottom < 50) {
                const lastTab = mainTabs[mainTabs.length - 1].id;
                if (activeTab !== lastTab) {
                    setActiveTab(lastTab);
                }
                return;
            }

            // Find which section is currently in view
            let currentTab = mainTabs[0].id;

            for (const tab of mainTabs) {
                const sectionElement = sectionRefs.current[tab.id];
                if (sectionElement) {
                    // Get element position relative to the viewport
                    const rect = sectionElement.getBoundingClientRect();
                    const sectionTop = rect.top;

                    // Add a small offset to improve detection
                    if (sectionTop <= 150) {
                        currentTab = tab.id;
                    }
                }
            }

            if (currentTab !== activeTab) {
                setActiveTab(currentTab);
            }
        };

        const contentElement = contentRef.current;
        contentElement.addEventListener('scroll', handleScroll);

        // Trigger initial scroll detection
        handleScroll();

        return () => {
            contentElement.removeEventListener('scroll', handleScroll);
        };
    }, [activeStep, activeTab, sectionsInitialized]);


    const showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        console.log("Showing snackbar:", message, severity); // Debug log
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };
    const handleCancelClick = () => {
        navigate(`${routes.academics}`);
    };
    return (
        <>
            <KenSnackbar
                open={snackbarOpen}
                message={snackbarMessage}
                severity={snackbarSeverity}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} // Change to top position
            />
            {isLoading &&
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                    <KenLoader />
                </Box>
            }
            <Box className={classes.root}>
                <Paper className={classes.leftPanel} elevation={0}>
                    <Stepper activeStep={activeStep} orientation="vertical" className={classes.stepperRoot}>
                        {steps.map((label, index) => (
                            <Step
                                key={label}
                                className={`
                                ${classes.step}
                                ${index === activeStep ? classes.activeStep : ''}
                                ${completedSteps.includes(index) ? classes.completedStep : ''}
                            `}
                                completed={completedSteps.includes(index)}
                            >
                                <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {activeStep === 1 && (
                        <>
                            {/* Main tabs */}
                            <List className={classes.tabsList}>
                                {mainTabs.map((tab) => (
                                    <ListItem
                                        key={tab.id}
                                        button
                                        className={`${classes.tabItem} ${activeTab === tab.id ? classes.tabItemActive : ''}`}
                                        onClick={() => handleTabClick(tab.id)}
                                    >
                                        <ListItemIcon className={`${classes.tabIcon} ${activeTab === tab.id ? classes.activeTabIcon : ''}`}>
                                            {tab.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={tab.label}
                                            className={`${classes.tabText} ${activeTab === tab.id ? classes.activeTabText : ''}`}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    )}
                </Paper>

                <Paper className={classes.rightPanel} elevation={0}>
                    <Box className={classes.contentArea} ref={contentRef}>
                        {activeStep === 0 ? (
                            <form id="assessment-form" onSubmit={handleSubmit(onSubmit)}>
                                <Box className={classes.formControl}>
                                    <Typography variant="body1" className={classes.inputLabel}>
                                        Assignment title <span className={classes.requiredIndicator}>*</span>
                                    </Typography>
                                    <Controller
                                        name="name"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                placeholder="Enter assignment"
                                                variant="outlined"
                                                className={classes.textField}
                                            />
                                        )}
                                    />
                                </Box>

                                {/* <Box className={classes.formControl}>
                                <Typography variant="body1" className={classes.inputLabel}>
                                    Select Program
                                </Typography>
                                <Controller
                                    name="program"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <FormControl variant="outlined" className={classes.select}>
                                            <Select
                                                {...field}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    if (selected === '') {
                                                        return <span style={{ color: '#aaa', fontStyle: 'normal', textAlign: 'left', fontFamily: 'inherit' }}>Select</span>;
                                                    }
                                                    return selected;
                                                }}
                                                sx={{
                                                    fontFamily: 'inherit',
                                                    textAlign: 'left',
                                                }}
                                            >
                                                <MenuItem value="" disabled sx={{ fontStyle: 'normal', fontFamily: 'inherit' }}>
                                                    Select
                                                </MenuItem>
                                                <MenuItem value="program1">Program 1</MenuItem>
                                                <MenuItem value="program2">Program 2</MenuItem>
                                                <MenuItem value="program3">Program 3</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                            </Box> */}

                                <Box className={classes.formControl}>
                                    <Typography variant="body1" className={classes.inputLabel}>
                                        Description
                                    </Typography>
                                    <Controller
                                        name="description"
                                        control={control}
                                        defaultValue=""
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                placeholder="Enter text"
                                                variant="outlined"
                                                multiline
                                                rows={6}
                                                className={classes.textarea}
                                            />
                                        )}
                                    />
                                </Box>
                                <Box className={classes.formControl} sx={{ textAlign: "start" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isFileUploadEnabled}
                                                onChange={() => {
                                                    setIsFileUploadEnabled(!isFileUploadEnabled)
                                                    if (!isFileUploadEnabled) {
                                                        setFileDetail({ fileName: "", filecontent: "" })
                                                    }
                                                }}
                                            />
                                        }
                                        label="Enable additional file upload"
                                    />
                                </Box>

                                {isFileUploadEnabled && (
                                    <Box
                                        sx={{
                                            border: '2px dashed #0174B7',
                                            borderRadius: '0.75rem',
                                            backgroundColor: '#E6F1F8',
                                            p: 3,
                                            textAlign: 'center'
                                        }}
                                    >
                                        {(!fileDetial.fileName) &&
                                            <>
                                                <input type="file"
                                                    style={{ display: 'none' }}
                                                    id="file-upload"
                                                    onChange={handleFileChange}
                                                />
                                                <label htmlFor="file-upload">
                                                    <Button
                                                        onClick={() => document.getElementById('file-upload')?.click()}
                                                        sx={{
                                                            backgroundColor: 'white',
                                                            color: '#0174B7',
                                                            minWidth: '150px',
                                                            cursor: 'pointer',
                                                            borderRadius: "0.75rem !important",
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}
                                                    >
                                                        Browse file
                                                    </Button>
                                                </label>
                                                <Box mt={1} color="text.secondary">
                                                    or Drag & Drop file to upload
                                                </Box>
                                                <Divider sx={{ my: 2, border: '1px solid #B0B0B0' }} />
                                                <Box color="text.secondary" fontSize="small">
                                                    Supported Format
                                                </Box>
                                            </>}
                                        {fileDetial.fileName && (
                                            <>
                                                <div style={{ textAlign: "end" }} onClick={() => {
                                                    setFileDetail({ fileName: "", filecontent: "" })
                                                }}>
                                                    <Close />
                                                </div>
                                                <Box mt={1} color="primary.main">
                                                    Selected file: {fileDetial.fileName}
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                )}
                            </form>
                        ) : (
                            <div>
                                {/* Availability Settings Section */}
                                <div
                                    ref={(el) => sectionRefs.current['Availability'] = el}
                                    id="availability-section"
                                >
                                    <Typography className={classes.sectionTitle}>
                                        Availability Settings
                                    </Typography>
                                    <Box className={classes.sectionContent}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <Availability assignData={assignData} setAssignData={setAssignData} />
                                        </FormControl>
                                    </Box>
                                    <Divider className={classes.sectionDivider} />
                                </div>

                                {/* Grade Settings Section */}
                                <div
                                    ref={(el) => sectionRefs.current['Grade'] = el}
                                    id="grade-section"
                                >
                                    <Typography className={classes.sectionTitle}>
                                        Grade Settings
                                    </Typography>
                                    <Box className={classes.sectionContent}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <GradeSettings data={assignData} handleChange={handleChange} from="assign"/>
                                        </FormControl>
                                    </Box>
                                    <Divider className={classes.sectionDivider} />
                                </div>

                                {/* Submission Section */}
                                <div
                                    ref={(el) => sectionRefs.current['Submission'] = el}
                                    id="submission-section"
                                >
                                    <Typography className={classes.sectionTitle}>
                                        Submission
                                    </Typography>
                                    <Box className={classes.sectionContent}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <SubmissionSettings
                                                assignData={assignData}
                                                handleCheckBoxChange={handleCheckBoxChange}
                                                handleChange={handleChange}
                                                fileFormatLists={fileFormatLists}
                                                handleSubmissionFileType={handleSubmissionFileType}

                                            />
                                        </FormControl>
                                    </Box>
                                    <Divider className={classes.sectionDivider} />
                                </div>

                                {/* Feedback Section */}
                                <div
                                    ref={(el) => sectionRefs.current['Feedback'] = el}
                                    id="feedback-section"
                                >
                                    <Typography className={classes.sectionTitle}>
                                        Feedback
                                    </Typography>
                                    <Box className={classes.sectionContent}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <Feedback
                                                assignData={assignData}
                                                handleCheckBoxChange={handleCheckBoxChange}
                                            />
                                        </FormControl>
                                    </Box>
                                    <Divider className={classes.sectionDivider} />
                                </div>

                                {/* Tags Section */}
                                <div ref={(el) => (sectionRefs.current['tags'] = el)} id="tags-section">
                                    <Typography className={classes.sectionTitle}>Tags</Typography>
                                    <Box className={classes.sectionContent}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <Typography variant="body1" className={classes.inputLabel}>
                                                Tags(Press enter to add)
                                            </Typography>
                                            <KenInput
                                                placeholder="Type to add tags"
                                                variant="outlined"
                                                className={classes.textField}
                                            />
                                        </FormControl>
                                    </Box>
                                </div>
                            </div>
                        )}
                    </Box>

                    {/* Bottom fixed button area */}
                    <Box className={classes.buttonArea}>
                        {activeStep === 1 && (
                            <Button
                                variant="text"
                                onClick={() => setActiveStep(0)}
                                style={{ marginRight: 'auto' }}
                            >
                                Back
                            </Button>
                        )}
                        <Button
                            variant="text"
                            className={classes.cancelButton}
                            onClick={handleCancelClick}
                        >
                            Cancel
                        </Button>
                        {activeStep === 0 ? (
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.saveButton}
                                type="submit"
                                form="assessment-form"
                            >
                                Save & proceed to assignment settings
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSave}
                                className={classes.saveButton}
                            >
                                Save settings
                            </Button>
                        )}
                    </Box>
                </Paper>
            </Box>

        </>
    );
};

export default AssignmentForm;